import styled from 'styled-components';

import { Colors } from "../../../../../../constants";

export const NoTrackingContainer = styled.div`
  display: flex;
  align-items: center;
  height: 22px;
`;

export const NoTrackingSpan = styled.span`
  margin-left: 10px;
  color: ${Colors.SECONDARY_GREY};
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
`;